import { classNames } from '@dimjs/utils';
import { useMemo } from 'react';
import { px2rem } from '../utils';
import { CommonPropsWithChildren } from '../utils/native-props';
import './style.less';

export type Timeline2Props = {
  labelWidth?: number;
} & CommonPropsWithChildren<{
  /**
   * label的fontsize
   */
  '--timeline-label-fontsize': string;
  /**
   *1. 中间ICON尺寸，宽高相同，默认值：px2rem(20)
   */
  '--timeline-icon-size': string;
  /**
   * 默认值：px2rem(200)
   */
  '--timeline-left-width': string;
  /**
   * 1. 设置label高度后，行高也邓毅改值
   * 2. 设置后 --timeline-label-line-height配置失效
   */
  '--timeline-label-height': string;
  /**
   * 先于icon之间的间距
   */
  '--timeline-line-icon-gap': string;
  /**
   * 线的宽度，默认值：px2rem(2)
   */
  '--timeline-line-width': string;
  /**
   *1. 行高只能设置数字比例，默认1.5
   */
  '--timeline-label-line-height': number;
}>;

/**
 *
 * @param props
 * @returns
 *
 * ```
 * 1. label的font-size必须通过var css来设置，默认值px2rem(28)
 * 2. 设置--timeline-label-height后，--timeline-label-line-height配置失效
 * 3. 设置fontSize、height时，使用px2rem包装
 * ```
 */
export const Timeline2 = (props: Timeline2Props) => {
  const commonProps = useMemo(() => {
    const innerStyle = props.style || {};
    const iconSize = parseFloat(innerStyle['--timeline-icon-size'] || px2rem(20));
    const labelHeight = innerStyle['--timeline-label-height'];
    const fontSize = parseFloat(innerStyle['--timeline-label-fontsize'] || px2rem(28));
    if (labelHeight) {
      innerStyle['--timeline-label-line-height'] = labelHeight as unknown as number;
      const height = parseFloat(labelHeight);
      innerStyle['--timeline-icon-padding-top'] = `${(height - iconSize) / 2}rem`;
    } else {
      const lineHeight = innerStyle['--timeline-label-line-height'] || 1.5;
      innerStyle['--timeline-icon-padding-top'] = `${(fontSize * lineHeight - iconSize) / 2}rem`;
    }
    innerStyle['--timeline-label-fontsize'] = `${fontSize}rem`;
    innerStyle['--timeline-left-width'] = innerStyle['--timeline-left-width'] || px2rem(200);
    innerStyle['--timeline-line-width'] = innerStyle['--timeline-line-width'] || px2rem(2);
    innerStyle['--timeline-line-icon-gap'] = innerStyle['--timeline-line-icon-gap'] || '0px';
    innerStyle['--timeline-icon-size'] = `${iconSize}rem`;
    return {
      style: innerStyle,
    };
  }, [props.style]);

  return (
    <div className={classNames('v-timeline2', props.className)} style={commonProps?.style}>
      {props.children}
    </div>
  );
};
